import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectPaginator = state => state.get('paginator', initialState);

const makeSelectCurrentPage = () =>
  createSelector(selectPaginator, selectedState => selectedState.get('currentPage'));

const makeSelectItemsPerPage = () =>
  createSelector(selectPaginator, selectedState =>
    selectedState.get('itemsPerPage'),
  );

const makeSelectPaginator = () =>
  createSelector(selectPaginator, selectedState => ({
    total: selectedState.get('total'),
    lastPage: selectedState.get('lastPage'),
    itemsPerPage: selectedState.get('itemsPerPage'),
    currentPage: selectedState.get('currentPage'),
  }));



export {
  selectPaginator,
  makeSelectCurrentPage,
  makeSelectItemsPerPage,
  makeSelectPaginator,
};
